import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/app-skeleton';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

const SKELETON_CARD_KEYS: readonly string[] = ['sk-thesis-0', 'sk-thesis-1', 'sk-thesis-2'];

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function DebateSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2"><Skeleton className="h-7 w-12 rounded-full" /><Skeleton className="h-7 w-16 rounded-full" /><Skeleton className="h-7 w-16 rounded-full" /><Skeleton className="h-7 w-14 rounded-full" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-4">{t0}<div className="flex items-center gap-1"><Skeleton className="h-7 w-16 rounded-full" /><Skeleton className="h-7 w-12 rounded-full" /></div>{SKELETON_CARD_KEYS.map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(key) {
  return <div key={key} className="flex flex-col gap-3 rounded-card border border-border-primary p-4"><div className="flex items-center gap-2"><Skeleton className="size-8 rounded-full" /><Skeleton className="h-4 w-24" /><Skeleton className="h-4 w-16" /></div><Skeleton className="h-4 w-3/4" /><Skeleton className="h-4 w-1/2" /><div className="flex items-center gap-4"><Skeleton className="h-8 w-16" /><Skeleton className="h-8 w-16" /><Skeleton className="h-8 w-16" /></div></div>;
}